<template>
    <CardPage :section="6" :page="4" :nextDisabled="nextDisabled">
        <Carousel :length="strategiesOrder.length" @change="change">
            <template v-slot:default="slotProps">
                <v-container fluid pa-0>
                    <v-layout row wrap align-center>
                        <v-flex xs12>
                            <ResponsiveImage
                                :src="strategies[strategiesOrder[slotProps.index]].image"
                                :alt="strategies[strategiesOrder[slotProps.index]].title"
                                flex="xs8"
                            ></ResponsiveImage>
                            <p class="headline text-xs-center">{{ strategies[strategiesOrder[slotProps.index]].title }}</p>
                            <p>{{ strategies[strategiesOrder[slotProps.index]].text }}</p>
                        </v-flex>
                    </v-layout>
                </v-container>
            </template>
        </Carousel>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        strategies: get('section6/strategies'),
        strategiesOrder: get('section6/strategiesOrder'),
        allStrategiesVisited: get('section6/allStrategiesVisited')
    },
    methods: {
        change(index) {
            this.$store.set(`section6/strategies@${index + 1}.visited`, true);
        },
        nextDisabled() {
            return !this.allStrategiesVisited;
        }
    }
};
</script>
